var _g, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgCategoryDonor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 182,
    viewBox: "0 0 182 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_811_3954)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 91,
    r: 71,
    fill: "#473F7A"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 81,
    r: 78,
    fill: "url(#paint0_linear_811_3954)",
    fillOpacity: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_811_3954",
    x: 0,
    y: 0,
    width: 182,
    height: 182,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_811_3954"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_811_3954",
    x1: 130.52,
    y1: 3,
    x2: 44.72,
    y2: 144.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416667,
    stopColor: "#BED8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C9BCD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgCategoryDonor);
export default __webpack_public_path__ + "static/media/bg-category-donor.9d7a99db427e145162f1de5f96b91171.svg";
export { ForwardRef as ReactComponent };